import React from 'react';

import { Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
    ReactHookFormIntlNumberInput,
    ReactHookFormSwitch,
} from 'common/components/form';

import CostWorkArrayRanges from './CostWorkArrayRanges';

const CostWorkFields = ({ control, getValues, disabled, setValue }) => {
    const { t } = useTranslation();
    const [workCostActive] = useWatch({
        control,
        name: ['work_cost_active'],
    });
    return (
        <>
            <Grid container>
                <Grid pl={1} size={{ md: 4, xs: 18 }}>
                    <ReactHookFormSwitch
                        control={control}
                        disabled={disabled}
                        fullWidth
                        label={t('Active')}
                        labelPlacement="start"
                        name="work_cost_active"
                    />
                </Grid>
                <Grid size={{ md: 5, xs: 18 }}>
                    <ReactHookFormIntlNumberInput
                        allowNegativeValue={false}
                        append="%"
                        control={control}
                        disabled={disabled || !workCostActive}
                        fullWidth
                        label={t('Monthly cost')}
                        min={0}
                        name="financial_work_cost_month"
                        step="any"
                    />
                </Grid>
                <Grid size={{ md: 5, xs: 18 }}>
                    <ReactHookFormIntlNumberInput
                        allowNegativeValue={false}
                        append="%"
                        control={control}
                        disabled={disabled || !workCostActive}
                        fullWidth
                        label={t('Financing')}
                        min={0}
                        name="percentage_work_funding"
                        step="any"
                    />
                </Grid>
            </Grid>

            <Grid container mt={2}>
                <Grid size={18}>
                    <CostWorkArrayRanges
                        control={control}
                        disabled={disabled || !workCostActive}
                        getValues={getValues}
                        name="work_cost_ranges"
                        setValue={setValue}
                        title={t('Months of work completion')}
                    />
                </Grid>
            </Grid>
        </>
    );
};

CostWorkFields.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    getValues: PropTypes.func,
    setValue: PropTypes.func,
};

export default CostWorkFields;
